// extracted by mini-css-extract-plugin
module.exports = {"s9w7e37":"s9w7e37"};